import { render, staticRenderFns } from "./EmotionSlider.vue?vue&type=template&id=364c6940&scoped=true&"
import script from "./EmotionSlider.vue?vue&type=script&lang=js&"
export * from "./EmotionSlider.vue?vue&type=script&lang=js&"
import style0 from "./EmotionSlider.vue?vue&type=style&index=0&id=364c6940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c6940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
